const baseUrl = {
  BASE_API: ''
};
switch (process.env.NODE_ENV) {
  case 'development':
    baseUrl.BASE_API = '';
    break;
  case 'production':
    baseUrl.BASE_API = '/ocean-plan';
    break;
}

export default baseUrl;